import { render } from "./CarouselItem.vue?vue&type=template&id=74774c01"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import "./CarouselItem.vue?vue&type=style&index=0&id=74774c01&lang=css"

import exportComponent from "C:\\Users\\Maraki(Lika)\\Desktop\\zowitech work\\seregela_frontend_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__